import { Mutation, Action, getModule, VuexModule, Module } from 'vuex-module-decorators'
import store from "@/store";

@Module({
    name: 'UserInfo',
    dynamic: true, // dynamic: true: 动态创建动态模块,即new Vuex.Store({})里面不用注册的.空着就行,
    namespaced: true, // 命名空间
    store, // store,当前模块注册到store上.也可以写在getModule上,即getModule(PassengerStore,store)
})
export default class UserInfo extends VuexModule {
    public userName: string | null = null
    public userId: string | null = null
    public userPhone: string | null = null
    public department: string | null = null
    public buttons: any[] = []
    public userList: any[] = []
    public deparmentList: any[] = []

    @Mutation
    SET_USER_INFO(data: { realName: string; id: string; departmentName: string; phone: string }) {
        const {realName, id, departmentName, phone} = data
        this.userId = id
        this.userName = realName
        this.userPhone = phone
        this.department = departmentName
    }
    @Mutation
    SET_BUTTONS(data: any[]) {
        this.buttons = data
    }
    @Mutation
    SET_USER_LIST(data: any) {
        this.userList = data
    }
    // @Mutation
    // SET_DEPARMENT_LIST(data: any[]) {
    //     this.deparmentList = data
    // }
}

export const UserModule = getModule(UserInfo)